import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloating = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
          // Use requestAnimationFrame to batch DOM reads/writes and avoid forced layout
          window.requestAnimationFrame(() => {
            if (window.pageYOffset > 500) {
              setIsVisible(true);
            } else {
              setIsVisible(false);
            }
          });
        };
        // Passive listener improves scroll performance and prevents forced reflow
        window.addEventListener("scroll", toggleVisibility, { passive: true });
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <>
            {isVisible && (
                <a
                    href="https://wa.me/523317658536"
                    className="whatsapp-float"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Contactanos en WhatsApp"
                    data-aos="fade-left"
                    data-aos-duration="1200"
                    data-aos-delay="200"
                >
                    <FaWhatsapp className="whatsapp-icon" />
                </a>
            )}
        </>
    );
};

export default WhatsAppFloating;
